import React, { Component } from 'react';
import { Container, Tabs, Tab, Nav } from 'react-bootstrap';

export default class BlobTabs extends Component {
  handleSelect = (key) => {
    if (this.props.onSelect) {
      this.props.onSelect(key);
    }
  }

  renderIcon(descriptor) {
    if (!descriptor.icon) return null;
    const Icon = descriptor.icon;
    return <Icon/>;
  }

  renderExpanded() {
    const { descriptors, activeKey } = this.props;
    return (
      <Container className="blob-header-row main-tabs">
        <Tabs activeKey={activeKey} onSelect={this.handleSelect}>
          {descriptors.filter(d => !d.hidden).map(d => (
            <Tab
              key={d.key}
              eventKey={d.key}
              disabled={d.disabled}
              title={<>{this.renderIcon(d)} {d.title}</>}
            />
          ))}
        </Tabs>
      </Container>
    );
  }

  renderCompact() {
    const { descriptors, activeKey } = this.props;
    return (
      <Nav className="main-tabs compact" activeKey={activeKey} onSelect={this.handleSelect}>
        {descriptors.filter(d => !d.hidden).map(d => (
          <Nav.Item key={d.key}>
            <Nav.Link eventKey={d.key} disabled={d.disabled} className={d.key === activeKey ? "active" : ""}>
              {this.renderIcon(d)} {d.title}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    );
  }

  render() {
    return this.props.compact ? this.renderCompact() : this.renderExpanded();
  }
}
